<template>
	<div>
		<vx-card
			title="Список заявок"
			class="p-6"
		>
			<vs-table
			:data="sharingList"
			:stripe="true"
			:search="true"
			:pagination="true"
			:maxItems="20"
			noDataText="Элементов не найдено"
			id="div-with-loading"
			>
				<template slot="thead">
					<vs-th> # </vs-th>
					<vs-th> Предмет </vs-th>
					<vs-th> Подробнее </vs-th>
					<vs-th> Статус </vs-th>
				</template>

				<template slot-scope="{ data }">
					<vs-tr :key="indextr" v-for="(tr, indextr) in data">
						<vs-td :data="data[indextr].id">
							{{ data[indextr].id }}
						</vs-td>

						<vs-td :data="data[indextr].name">
							{{ data[indextr].name }}
						</vs-td>

						<vs-td>
							<p class="mb-3">Адрес: <span class="text-primary">{{ data[indextr].address }}</span></p>
							<p class="mb-3">ФИО: <span class="text-primary">{{ data[indextr].full_name }}</span></p>
							<p class="mb-3">Описание: <span class="text-primary">{{ data[indextr].description }}</span></p>
							<p class="mb-3">Цена: <span class="text-primary">{{ data[indextr].price }}</span></p>
							<p class="mb-3">Телефон: <a :href="`tel:data[indextr].phone`" class="text-primary">{{ data[indextr].phone }}</a></p>
						</vs-td>

						<vs-td>
							{{ data[indextr].in_using ? 'Использован' : 'Не использован' }}
							{{ data[indextr].is_closed ? 'Открыт' : 'Закрыт' }}
						</vs-td>
					</vs-tr>
				</template>
			</vs-table>
		</vx-card>
	</div>
</template>

<script>
import { API_URL } from '@/.env'

export default {
  data: () => ({
	sharingList: [
	],
    BASE_URL: API_URL,
	activeCreatePrompt: false,
  }),
  components: {},
  watch: {},
  computed: { },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
	},
    getAllSharing() {
      this.$load(async () => {
        let res = (await this.$api.sharing.getAll()).data;

        res.results.forEach((sharing) => {
          sharing.date_created = this.formatDate(sharing.date_created);
        });

        this.sharingList = res.results;
      });
    },
  },
  created() {},
  mounted() {
    this.getAllSharing();
  },
};
</script>